import {
  AppleLogo,
  GoogleHealthConnectLogo,
  HeadspaceLogo,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { SVGIconComponent } from 'types/svgr';

import LandingPageIntegrations from '@/app/components/LandingPage/LandingPageIntegrations';

const StressIntegrations = () => {
  const t = useTranslations();
  return (
    <section className="py-24" data-cy="stress-integrations">
      <LandingPageIntegrations
        description="stress_integration_copy"
        logoColor="black"
        integrations={[
          {
            description: 'womens_integrations_apple_health_copy',
            Logo: AppleLogo as SVGIconComponent,
            name: t('integrations_apple_health_kit'),
          },
          {
            description: 'stress_integration_headspace',
            Logo: HeadspaceLogo as SVGIconComponent,
            name: t('integrations_app_name_headspace'),
          },
          {
            description: 'womens_integrations_health_connect_copy',
            Logo: GoogleHealthConnectLogo as SVGIconComponent,
            name: t('integrations_google_health_connect'),
          },
        ]}
        title="pop_integrations_title"
      />
    </section>
  );
};
export default StressIntegrations;
